import { ICON__eye_slash_solid, ICON__eye_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_slice_ui, use_slice_user } from '@/hooks/store/use_slices';
import i18n_page_generation from '@/locales/keys/i18n_page_generation.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { FN_USER_SETTINGS__update } from '@/utils/utils_client';
import { useTranslation } from 'react-i18next';

export function G_BUTTON__prompt_hide_unused_tokens() {
  /*
   * STORE
   */
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_GENERATION);

  const { user_settings } = use_slice_user(['user_settings']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  const tooltip_title = t(
    user_settings.generation_prompt_hide_unused_tokens
      ? i18n_page_generation.sidebar_user_input.button.hide_unused_tokens.tooltip.title_show
      : i18n_page_generation.sidebar_user_input.button.hide_unused_tokens.tooltip.title_hide,
  );
  /*
   * EVENTS
   */
  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let settings_new = user_settings.clone({ generation_prompt_hide_unused_tokens: !user_settings.generation_prompt_hide_unused_tokens });

    await FN_USER_SETTINGS__update(settings_new);
  }

  /*
   * METHODS
   */

  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */

  return (
    <UI_PRIMITIVE__tooltip {...{ tooltip_title }}>
      <UI_PRIMITIVE__button size="rect-10-5" variant={'no-border-on-bar'} disabled={is_disabled()} {...{ onClick }}>
        {user_settings.generation_prompt_hide_unused_tokens ? <ICON__eye_solid className="size-3" /> : <ICON__eye_slash_solid className="size-3" />}
      </UI_PRIMITIVE__button>
    </UI_PRIMITIVE__tooltip>
  );
}
